export function getInitialProductData(product) {
    const {product_data = []} = product;

    const productDataCurrent =
        product_data.find(el => el.id === product.product_data_active_id) ||
        product_data[0] ||
        null;

    return {
        // productData,
        productDataCurrent,
    };
}
